export { default } from './Pagination';
export { default as Pagination } from './Pagination';
